import { Route } from '@angular/router';
import { canActivate } from './shared';

export const appRoutes: Array<Route> = [
  {
    path: 'auth',
    loadChildren: async () => import('./auth').then((m: { authRoutes: Array<Route> }) => m.authRoutes)
  },
  {
    path: 'process/documents/:processId',
    loadComponent: async () =>
      import('./public/views/public-document-upload/public-document-upload.component')
        .then(m => m.PublicDocumentUploadComponent)
  },
  {
    path: 'public/agreement/:processId',
    loadComponent: async () =>
      import('./public/views/agreement-preview/agreement-preview.component')
        .then(m => m.AgreementPreviewComponent)
  },
  {
    path: 'public/agreement/:processId/sign',
    loadComponent: async () =>
      import('./public/views/signature-capture/signature-capture.component')
        .then(m => m.SignatureCaptureComponent)
  },
  {
    path: 'public/fica-upload/:processId',
    loadComponent: async () =>
      import('./public/views/fica-upload/fica-upload.component')
        .then(m => m.FicaUploadComponent)
  },
  {
    path: 'apply',
    loadChildren: async () => import('./public/public.routes').then(m => m.publicRoutes)
  },
  {
    path: '',
    canActivate: [canActivate],
    loadChildren: async () =>
      import('./dashboard.routes').then((m: { dashboardRoutes: Array<Route> }) => m.dashboardRoutes)
  },
];
